"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/for-each");

var _context;

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

var _exportNames = {
  Form: true
};
exports.Form = void 0;

var _react = _interopRequireDefault(require("react"));

var _forms = require("@redwoodjs/forms");

_forEachInstanceProperty(_context = _Object$keys(_forms)).call(_context, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _forms[key];
    }
  });
});

/**
 * @deprecated Please import from "@redwoodjs/forms"
 */
var Form = function Form(props) {
  console.warn("\n  Deprecation notice, forms have moved:\n    Pleas use:\n    'import { Form } from \"@redwoodjs/forms\"'\n    instead of:\n    'import { Form } from \"@redwoodjs/web\"'\n  ");
  return /*#__PURE__*/_react.default.createElement(_forms.Form, props);
};

exports.Form = Form;